<table>
    <thead>
        <tr>
            <th class="subtable id sortable" (click)="toOrderBy('1')" [appSort]="etiquetadoresCultivo" data-order="desc" data-name="etiquetadorId">
              {{'informe-cultivos.etiquetadores.id' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('1')"></i>
              </div>
            </th>
            <th class="subtable string sortable" (click)="toOrderBy('2')" [appSort]="etiquetadoresCultivo" data-order="desc" data-name="desEtiquetador">
              {{'informe-cultivos.etiquetadores.etiquetador' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('2')"></i>
              </div>
            </th>
            <th class="subtable string sortable" (click)="toOrderBy('3')" [appSort]="etiquetadoresCultivo" data-order="desc" data-name="desAlmacen">
              {{'global.almacen' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('3')"></i>
              </div>
            </th>
            <th class="subtable string sortable" (click)="toOrderBy('4')" [appSort]="etiquetadoresCultivo" data-order="desc" data-name="desMarca">
              {{'informe-cultivos.etiquetadores.marca' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('4')"></i>
              </div>
            </th>
            <th class="subtable number sortable" (click)="toOrderBy('5')" [appSort]="etiquetadoresCultivo" data-order="desc" data-name="sumaKgImpresosEfectivos">
              {{'global.confeccionKg' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('5')"></i>
              </div>
            </th>
            <th class="subtable number sortable" (click)="toOrderBy('6')" [appSort]="etiquetadoresCultivo" data-order="desc" data-name="sumaCantidadDesignada">
              {{'informe-cultivos.etiquetadores.designado' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('6')"></i>
              </div>
            </th>
            <th class="subtable progress sortable" (click)="toOrderBy('7')" [appSort]="etiquetadoresCultivo" data-order="desc" data-name="porcentajeImpresosDesignados">
              {{'global.porcentajeConfeccionado' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('7')"></i>
              </div>
            </th>
        </tr>
    </thead>
    <tbody *ngFor="let etiquetador of etiquetadoresCultivo; trackBy: trackByEtiquetadorId">
        <tr>
            <td class="id">{{etiquetador.etiquetadorId}}</td>
            <td class="string">{{etiquetador.desEtiquetador}}</td>
            <td class="string">{{etiquetador.desAlmacen}}</td>
            <td class="string">{{etiquetador.desMarca}}</td>
            <td class="number">{{etiquetador.sumaKgImpresosEfectivos  | number : '1.2-2': defaultLanguage}}</td>
            <td class="number">{{etiquetador.sumaCantidadDesignada  | number : '1.2-2': defaultLanguage}}</td>
            <td class="progress"><progress
                [ngClass]="{'exceeded': etiquetador.porcentajeImpresosDesignados > 100}"
                value="{{etiquetador.porcentajeImpresosDesignados}}"
                max="100"></progress><span>{{etiquetador.porcentajeImpresosDesignados.toFixed(2)| number : '1.2-2': defaultLanguage}}%</span>
        </td>
        </tr>
    </tbody>
    <tfoot *ngIf="!etiquetadoresCultivo || (etiquetadoresCultivo && etiquetadoresCultivo.length < 1)">
      <tr>
        <td colspan="7">
          {{'global.noContent' | translate}}
        </td>
      </tr>
  </tfoot>
</table>
